export default "__VITE_ASSET__65553bee__"